module.exports = __webpack_public_path__ + "static/media/logo_lif3_light.7d244121.svg";